// src/app/app.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { SeoService, AppLang } from './services/seo.service';
import { Subscription } from 'rxjs';

// ⬅️ Ajoute ici toutes les langues que tu sers réellement
const SUPPORTED_LANGS: AppLang[] = ['en', 'fr', 'es', 'hi', 'id'];

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit, OnDestroy {
  private subs = new Subscription();

  constructor(private translate: TranslateService, private seo: SeoService) { }

  ngOnInit(): void {
    this.translate.addLangs(SUPPORTED_LANGS);
    this.translate.setDefaultLang('en');

    // 1) Essaie d'abord de lire la langue depuis l'URL: /:locale/...
    const firstSeg = (typeof window !== 'undefined'
      ? window.location.pathname.split('/').filter(Boolean)[0] || ''
      : ''
    ).toLowerCase() as AppLang | '';
    const urlLang: AppLang | '' = SUPPORTED_LANGS.includes(firstSeg as AppLang)
      ? (firstSeg as AppLang)
      : '';

    // 2) Sinon, fallback sur la langue du navigateur
    const raw = (this.translate.getBrowserLang() || '').toLowerCase();
    const normalized = raw.split('-')[0] as AppLang | '';
    const browserLang: AppLang = SUPPORTED_LANGS.includes(normalized as AppLang)
      ? (normalized as AppLang)
      : 'en';

    const initialLang: AppLang = (urlLang || browserLang || 'en') as AppLang;

    // Première init de la langue + SEO
    this.translate.use(initialLang).subscribe({
      next: () => this.seo.setSeoForLang(initialLang, this.absUrl()),
      error: (err) => console.error('Erreur de traduction:', err),
    });

    // Mise à jour SEO sur changement de langue
    this.subs.add(
      this.translate.onLangChange.subscribe((e: LangChangeEvent) => {
        const newLang = (e.lang.split('-')[0] as AppLang) || 'en';
        const toApply: AppLang = SUPPORTED_LANGS.includes(newLang) ? newLang : 'en';
        this.seo.setSeoForLang(toApply, this.absUrl());
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private absUrl(): string {
    return typeof window !== 'undefined' ? window.location.href : 'https://swaptokens.app/';
  }
}
